<template>
  <div class="cbg-account-menu" ref="accountMenu">
    <button class="cbg-account-menu__close" @click="closeModal">
      <Svg class-name="cbg-account-menu__close-ico" icon-id="#close"/>
    </button>
    <div class="cbg-account-menu__info">
      <div class="cbg-account-menu__img">
        <span v-if="!userData.avatar" class="cbg-account-menu__img-default">{{nameLetter}}</span>
        <img v-else class="cbg-account-menu__img-content" :src="userData.avatar" alt="User photo">
      </div>
      <div class="cbg-account-menu__data">
        <p class="cbg-account-menu__data-name">{{userData.nickname}}</p>
        <p class="cbg-account-menu__data-email">{{userData.email}}</p>
      </div>
    </div>
    <div class="cbg-account-menu__list">
      <button class="cbg-account-menu__item" @click="openSettings">
        <Svg class-name="cbg-account-menu__item-ico" icon-id="#user"/>
        <span class="cbg-account-menu__item-text">Account settings</span>
        <Svg class-name="cbg-account-menu__item-ico" icon-id="#arrow-right"/>
      </button>
    </div>
    <button class="cbg-account-menu__logout" @click="()=>logOut(false)">
      <Svg class-name="cbg-account-menu__logout-ico" icon-id="#log-out"/>
      <span class="cbg-account-menu__logout-text">Log out</span>
    </button>
  </div>
</template>

<script>
import Input from "@/components/elements/Input.vue";
import Svg from "@/components/global/Svg.vue";
import AccountSettings from "@/components/parts/account/AccountSettings.vue";
import {userData} from "@/mixins/userData";
export default {
  name: 'AccountMenu',
  components: {
    AccountSettings,
    Svg,
    Input
  },
  mixins: [userData],
  methods: {
    closeModal() {
      if (this.updateContext) {
        this.updateContext('isOpen', false);
      }
    },

    openSettings() {
      if (this.updateContext) {
        this.updateContext('step', 1);
      }
    },

    handleOutsideClick(event) {
      const isOpenButton = event.target.closest('[data-id="login-btn"]');
      if (this.$refs.accountMenu && !this.$refs.accountMenu.contains(event.target) && !isOpenButton) {
        this.closeModal();
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
}
</script>